module.exports = __webpack_public_path__ + "c2479b8a6582e9f764ca12f93bdd2a.png";